module.exports = __webpack_public_path__ + "static/transparency-fd89ffad60397600fd4580f33ce09163.png";